export var SymbolLegend  = 'symbol';
export var DiscreteLegend = 'discrete';
export var GradientLegend = 'gradient';
